<template>
  <div class="add-gift">
    <div>
        <h1>
            <div class="left">{{pagename}}</div>
        </h1>
    </div>
    <!-- <headerNotice routerName="pagename"></headerNotice> -->
    <div v-loading="loading" class="content">
      <h1>
        {{pagename}}
        <span>
          （&nbsp;
          <i class="mustStar">*</i>&nbsp;必填）
        </span>
      </h1>
      <el-form
        ref="form"
        style="margin-left: 28% ;"
        :rules="rules"
        :model="form"
        label-width="150px"
      >
        <el-form-item label="分类: " prop="cateID">
          <el-select v-loading="opLoading" v-model="form.cateID" placeholder="请选择分类">
            <el-option
              v-for="item in classifylist"
              :key="item.cateID"
              :label="item.cateName"
              :value="item.cateID"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="输入语录: ">
          <el-input
            :rows="4"
            resize="none"
            type="textarea"
            class="input-el"
            v-model="form.customizationName"
            placeholder="请输入语录内容"
            maxlength="300"
          ></el-input>
        </el-form-item>

        <el-form-item label="排序: " prop="sort">
          <el-input class="input-el" v-model.number="form.sort" placeholder="请输入排序"></el-input>
        </el-form-item>

        <el-form-item style="margin-left: 10%;">
          <el-button :loading="btnLoading" @click="submit" type="primary" v-if="showsubmit">提交</el-button>
          <el-button @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  data() {
    return {
      pagename: "添加语录",
      type: 1, //页面类型 0查看，1新增，2编辑
      showsubmit:true,
      loading: false,
      opLoading: false,
      btnLoading: false,
      rules: {},
      form: {
        customizationType: 2,//图案
        customizationID: 0,
        cateID: "",
        customizationName: "",
        customizationImageUrl: "",
        sort: 0
      },
      classifylist: [], //分类列表
      accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
      headers: {
        Authorization: localStorage.getItem("accessToken")
      },
      // headers: {
      //   'Authorization': sessionStorage.getItem('accessToken'),
      // }, //正式头部
      uploadAction:
        this.$store.state.apiUrl + "/api/services/app/Image/UploadImage",
      imagesList: [],
      imagesDescList: [],
      baseUrl: this.$store.state.apiUrl
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getclassifylist({
      customizationType: 2
    }); //分类下拉框

    let type = this.$route.query.type;
    if (type==undefined) {
      type = 1;
    }
    if (type == 1) {
      //新增
      this.pagename = "新增语录";
    } else if (type == 0) {
      this.pagename = "查看语录";
      this.showsubmit = false;
      let params = { customizationID: this.$route.query.id };
      this.getCustomization(params);
    } else if (type == 2) {
      this.pagename = "编辑语录";
      let params = { customizationID: this.$route.query.id };
      this.getCustomization(params);
    }
    this.type = type;
  },
  mounted() {},
  methods: {
    //获取分类下拉框
    getclassifylist(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomizationCate/GetAllByCustomizationType",
        params: params,
        success(res) {
          self.classifylist = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //根据ID获取详情
    getCustomization(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminCustomization/Get",
        params: params,
        success(res) {
          self.form = res;
        },
        fail(res) {}
      });
    },

    //提交
    submit() {
      let self = this;
      self.btnLoading = true;
      if (self.type==1) {
        self.addCustomization();
      }else{
        self.editCustomization();
      }
      
    },

    //返回
    back() {
      this.$router.push({
        path: "/quotationsInformation"
      });
    },
    addCustomization() {
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomization/Create",
        data: self.form,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.$router.push({
            path: "/quotationsInformation"
          });
          self.btnLoading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //修改
    editCustomization() {
      let self = this;
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCustomization/Update",
        data: self.form,
        success(res) {
          self.$message({
            message: "修改成功",
            type: "success"
          });
          self.$router.push({
            path: "/quotationsInformation"
          });
          self.btnLoading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-gift {
  .content {
    padding: 20px 50px 0;
  }
  .tips {
    margin: -10px 0 12px 13%;
    color: #999;
    font-size: 12px;
  }
  .upload {
    width: 500px;
    // border: 1px solid #e4e4e4;
    // border-radius: 4px;
  }
  .input-el {
    width: 460px;
  }
}
h1 {
    padding: 20px 50px;
    border-bottom: 1px solid #dbdbdb;
    background: #F3F3F3;
    user-select: none;
    .left {
        border-left: 3px solid coral;
        padding-left: 10px;
        color: #666;
    }
}
</style>